import { Button } from "@etframework/ui.components";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const FieldTypeContainer = ({ onFieldTypeClick }) => {
  const { t } = useTranslation(["CustomFieldGroup"], {
    useSuspense: false,
  });

  const [showContainer, setShowContainer] = useState(false);

  const fieldOptions = [
    { title: t("FieldType.ShortText"), value: 0, icon: "fa-regular fa-a" },
    { title: t("FieldType.Number"), value: 1, icon: "fa-regular fa-hashtag" },
    { title: t("FieldType.Date"), value: 2, icon: "fa-regular fa-calendar" },
    { title: t("FieldType.YesNo"), value: 3, icon: "fa-regular fa-check" },
  ];

  return (
    <div className="field-type-container position-relative d-inline-block">
      <Button
        iconCss="fa-regular fa-plus"
        text={t("AddField")}
        className="btn btn-primary bg-blue-light-1 et-black shadow-sm w-auto"
        onClick={() => setShowContainer((prev) => !prev)}
      />

      {showContainer && (
        <div
          className="field-type-popup position-absolute z-3"
          style={{
            top: "calc(100% + 8px)", // positions below the button
            right: 0, // aligns with button's right side
          }}
        >
          <div
            className="p-2 bg-white rounded bc-bg-blue"
            style={{ height: "272px", width: "250px" }}
          >
            <div className="p-2">{t("FieldType.SelectFieldType")}</div>
            <div className="row gx-2 gy-3 px-3">
              {fieldOptions.map((option) => (
                <div
                  className="col-6 d-flex justify-content-center"
                  key={option.value}
                >
                  <button
                    type="button"
                    className="field-type-btn btn btn-outline-secondary d-flex flex-column justify-content-center align-items-center bc-bg-gray shadow-sm"
                    style={{ height: "90px", width: "90px" }}
                    onClick={() => {
                      onFieldTypeClick(option);
                      setShowContainer(false);
                    }}
                  >
                    <i
                      className={`${option.icon} et-darkest-gray fs-18 field-icon`}
                    />
                    <span className="mt-2 et-black fw-400 field-title">
                      {option.title}
                    </span>
                  </button>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
